import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { ArrowLeft, FileText, Download } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const SubjectMatterExpertise = () => {
  const knowledgeBases = [
    {
      title: "Federal Security Design Standards",
      description: "Comprehensive security requirements and design standards for federal buildings",
      type: "Standard",
      lastUpdated: "2024-01-10"
    },
    {
      title: "Historic Preservation Guidelines",
      description: "Guidelines for maintaining historic character while modernizing federal buildings",
      type: "Guideline",
      lastUpdated: "2024-02-15"
    },
    {
      title: "Security Threat Assessment Framework",
      description: "Methodology for assessing and addressing security threats in federal facility design",
      type: "Framework",
      lastUpdated: "2024-01-25"
    },
    {
      title: "Historic Building Renovation Standards",
      description: "Standards for renovating historic federal buildings while preserving their character",
      type: "Standard",
      lastUpdated: "2024-02-08"
    },
    {
      title: "Specialized Design Requirements Database",
      description: "Repository of specialized design requirements for various federal agencies",
      type: "Database",
      lastUpdated: "2024-02-20"
    }
  ];

  return (
    <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-6">
          <Link to="/gsa-channel" className="inline-flex items-center text-primary hover:text-primary/80 mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to GSA Channel
          </Link>
          <h1 className="text-3xl font-bold mb-2">Subject Matter Expertise Customization: Security & Historic Preservation</h1>
          <p className="text-muted-foreground">
            Specialized knowledge bases for integrating security requirements and historic preservation standards into federal building design.
          </p>
        </div>

        <div className="grid gap-6">
          {knowledgeBases.map((kb, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <CardTitle className="text-xl mb-2">{kb.title}</CardTitle>
                    <p className="text-muted-foreground">{kb.description}</p>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                      {kb.type}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      Updated: {kb.lastUpdated}
                    </span>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="flex gap-3">
                  <Button variant="outline" size="sm">
                    <FileText className="h-4 w-4 mr-2" />
                    View Details
                  </Button>
                  <Button variant="outline" size="sm">
                    <Download className="h-4 w-4 mr-2" />
                    Download
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
    </div>
  );
};

export default SubjectMatterExpertise;